<template>
  <svg class="form-style-collapse-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.18729 10L4.96854 10C5.02166 10 5.07166 9.98047 5.10291 9.94844L8.06229 6.88906L11.0217 9.94844C11.0529 9.98047 11.1029 10 11.156 10L11.9373 10C12.005 10 12.0446 9.94219 12.005 9.90078L8.33208 6.10313C8.19875 5.96563 7.92583 5.96563 7.79354 6.10313L4.12062 9.90078C4.08 9.94219 4.11958 10 4.18729 10Z" fill="#7C7B85" />
  </svg>
</template>

<script>
export default {
  name: 'CollapseArrow'
}
</script>
